import Vue from 'vue';
import Vuex from 'vuex';

import {
    modelState as appState,
    actions as appActions,
    mutations as appMutations,
    getters as appGetters,
} from './store-models/app-model';

import {
    modelState as contentState,
    actions as contentActions,
    mutations as contentMutations,
    getters as contentGetters,
} from './store-models/content-model';

import {
    modelState as metaState,
    actions as metaActions,
    mutations as metaMutations,
    getters as metaGetters,
} from './store-models/meta-model';

import {
    modelState as companyState,
    actions as companyActions,
    mutations as companyMutations,
    getters as companyGetters,
} from './store-models/company-model';

import {
    modelState as companiesState,
    actions as companiesActions,
    mutations as companiesMutations,
    getters as companiesGetters,
} from './store-models/companies-model';

import {
    modelState as requestState,
    actions as requestActions,
    mutations as requestMutations,
    getters as requestGetters,
} from './store-models/request-model';

import {
    modelState as requestsState,
    actions as requestsActions,
    mutations as requestsMutations,
    getters as requestsGetters,
} from './store-models/requests-model';

import {
    modelState as filtersState,
    actions as filtersActions,
    mutations as filtersMutations,
    getters as filtersGetters,
} from './store-models/filters-model';

import {
    modelState as featuredCompaniesState,
    actions as featuredCompaniesActions,
    mutations as featuredCompaniesMutations,
    getters as featuredCompaniesGetters,
} from './store-models/featured-companies-model';

import {
    modelState as featuredRequestsState,
    actions as featuredRequestsActions,
    mutations as featuredRequestsMutations,
    getters as featuredRequestsGetters,
} from './store-models/featured-requests-model';

import {
    modelState as requestFormState,
    actions as requestFormActions,
    mutations as requestFormMutations,
    getters as requestFormGetters,
} from './store-models/request-form-model';

import {
    modelState as queuedCompaniesState,
    actions as queuedCompaniesActions,
    mutations as queuedCompaniesMutations,
    getters as queuedCompaniesGetters,
} from './store-models/queued-companies-model';

import {
    modelState as loginState,
    actions as loginActions,
    mutations as loginMutations,
    getters as loginGetters,
} from './store-models/authentication-model';

import {
    modelState as forgottenPasswordState,
    actions as forgottenPasswordActions,
    mutations as forgottenPasswordMutations,
    getters as forgottenPasswordGetters,
} from './store-models/forgotten-password-model';

import {
    modelState as myPagesCustomerState,
    actions as myPagesCustomerActions,
    mutations as myPagesCustomerMutations,
    getters as myPagesCustomerGetters,
} from './store-models/my-pages-customer-model';

import {
    modelState as myPagesCompanyState,
    actions as myPagesCompanyActions,
    mutations as myPagesCompanyMutations,
    getters as myPagesCompanyGetters,
} from './store-models/my-pages-company-model';

import {
    modelState as searchProfileState,
    actions as searchProfileActions,
    mutations as searchProfileMutations,
    getters as searchProfileGetters,
} from './store-models/search-profile-model';

import {
    modelState as sendMailState,
    actions as sendMailActions,
    mutations as sendMailMutations,
    getters as sendMailGetters,
} from './store-models/send-mail-model';

import {
    modelState as ratingState,
    actions as ratingActions,
    mutations as ratingMutations,
    getters as ratingGetters,
} from './store-models/rating-model';

import {
    modelState as contractState,
    actions as contractActions,
    mutations as contractMutations,
    getters as contractGetters,
} from './store-models/contract-model';

Vue.use(Vuex);

export default () => {
    return new Vuex.Store({
        state: () => ({
            ...contentState(),
            ...appState(),
            ...metaState(),
            ...companyState(),
            ...companiesState(),
            ...featuredCompaniesState(),
            ...featuredRequestsState(),
            ...requestState(),
            ...requestsState(),
            ...filtersState(),
            ...requestFormState(),
            ...queuedCompaniesState(),
            ...loginState(),
            ...myPagesCustomerState(),
            ...myPagesCompanyState(),
            ...searchProfileState(),
            ...forgottenPasswordState(),
            ...sendMailState(),
            ...ratingState(),
            ...contractState(),
        }),
        actions: {
            ...contentActions,
            ...appActions,
            ...metaActions,
            ...companyActions,
            ...companiesActions,
            ...featuredCompaniesActions,
            ...featuredRequestsActions,
            ...requestActions,
            ...requestsActions,
            ...filtersActions,
            ...requestFormActions,
            ...queuedCompaniesActions,
            ...loginActions,
            ...myPagesCustomerActions,
            ...myPagesCompanyActions,
            ...searchProfileActions,
            ...forgottenPasswordActions,
            ...sendMailActions,
            ...ratingActions,
            ...contractActions,
        },
        mutations: {
            ...contentMutations,
            ...appMutations,
            ...metaMutations,
            ...companyMutations,
            ...companiesMutations,
            ...featuredCompaniesMutations,
            ...featuredRequestsMutations,
            ...requestMutations,
            ...requestsMutations,
            ...filtersMutations,
            ...requestFormMutations,
            ...queuedCompaniesMutations,
            ...loginMutations,
            ...myPagesCustomerMutations,
            ...myPagesCompanyMutations,
            ...searchProfileMutations,
            ...forgottenPasswordMutations,
            ...sendMailMutations,
            ...ratingMutations,
            ...contractMutations,
        },
        getters: {
            ...contentGetters,
            ...appGetters,
            ...metaGetters,
            ...companyGetters,
            ...companiesGetters,
            ...featuredCompaniesGetters,
            ...featuredRequestsGetters,
            ...requestGetters,
            ...requestsGetters,
            ...filtersGetters,
            ...requestFormGetters,
            ...queuedCompaniesGetters,
            ...loginGetters,
            ...myPagesCustomerGetters,
            ...myPagesCompanyGetters,
            ...searchProfileGetters,
            ...forgottenPasswordGetters,
            ...sendMailGetters,
            ...ratingGetters,
            ...contractGetters,
        },
    });
};



// WEBPACK FOOTER //
// ./src/store/index.js